import { PDFCheckBox, PDFDocument, PDFForm, PDFTextField } from "pdf-lib";
import { ProgramContainer } from "../entities/formTemplateDataType"

export const generateAndDownloadPDF = async (programContainer: ProgramContainer, lang='en') => {
    const pdfBytes = await generatePDF(programContainer);
    if (pdfBytes) {
        downloadFile(pdfBytes, 'application/pdf');
    }
}

export const generatePDF = async (programContainer: ProgramContainer, lang='en') => {
    if (!programContainer.pdfTemplate) return null;
    // const index = programContainer.pdfTemplate.indexOf(',');
    // const pdfData = programContainer.pdfTemplate.substring(index+1)
    // const pdfBytes = atob(pdfData);
    const pdfData = programContainer.pdfTemplate
    const pdfDoc = await PDFDocument.load(pdfData);
    const form = pdfDoc.getForm();
    if (!form) return null;

    populatePDFWithElementValues(programContainer, form, lang);
    makePDFReadOnly(form);

    // following code to verify the values of each field afer update.
    // const fields = form.getFields() ?? [];
    // fields.forEach(field => {
    //     const type = field.constructor.name;
    //     const name = field.getName();
    //     let val = null;
    //     switch(type) {
    //         case 'PDFTextField':
    //             val = (field as PDFTextField).getText();
    //             break;
    //         case 'PDFCheckBox':
    //             val = (field as PDFCheckBox).isChecked();
    //             break;
    //     };

    //     console.log(`name: ${name}, type: ${type}, value: ${val}`);
    // });


    const pdfBytes = await form.doc.save();
    return pdfBytes
}

export const downloadFile = (pdfData, mimeType) => {
    if (pdfData) {
        const blob = new Blob([pdfData], { type: mimeType});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'downloaded.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    } else {
        alert('No PDF loaded. Please select a PDF file first.');
    }
};

const populatePDFWithElementValues = (programContainer: ProgramContainer, form: PDFForm, lang='en') => {
    programContainer.ListOfFormSections.forEach((section,i) => {
        section.ListOfFormSubSections.forEach(subSec => {
            subSec.ListOfFormSectionElements.forEach(element => {
                //const fieldName = lang === 'en' ? element.ENUTitle : element.FRATitle;
                const fieldName = element.LoadBindName;
                if (fieldName && element.Value) {
                    let ft = getFieldAndType(form, fieldName);
                    let field = ft.field;
                    let type = ft.type;

                    switch (element.Datatype) {
                        case 'Text':
                        case 'Date':
                        case 'PostalCode':
                        case 'PhoneNumber':
                        case 'Number':
                        case 'Email':
                            if (type === 'PDFTextField' || type === 't') {
                                (field as PDFTextField).setText(element.Value);
                            }
                            break;
                        case 'Checkbox':
                            if (type === 'PDFCheckBox') {
                                element.Value?.toLowerCase() === 'y'? (field as PDFCheckBox).check() : (field as PDFCheckBox).uncheck();
                            }
                            break;
                        case 'CheckboxWithTextbox':
                            if (type === 'PDFTextField') {
                                (field as PDFTextField).setText(element.Value);
                                field.enableReadOnly();
                                const checkbox = form.getField(fieldName + '_checkbox');
                                const checkType = checkbox.constructor.name;
                                if (checkType === 'PDFCheckBox') {
                                    element.Checked ? (checkbox as PDFCheckBox).check() : (checkbox as PDFCheckBox).uncheck();
                                }
                            }
                            break;
                        case 'Address':
                            Object.keys(element.Address).forEach(key => {
                                const fieldKey = `${key}__${i}`
                                ft = getFieldAndType(form, fieldKey);
                                field = ft.field;
                                type = ft.type;
                                if (field) {
                                    if (type === 'PDFTextField' || type === 't') {
                                        (field as PDFTextField).setText(element.Address[key]);
                                    }
                                }
                            });
                            break;
                    }

                    if (field) {    
                        field.enableReadOnly();
                    }
                }
            });
        });
    });
    return form;
}

const getFieldAndType = (form: PDFForm, fieldName: string) => {
    let field = null;
    let type = null;
    try {
        field = form.getField(fieldName);
        type = field.constructor.name;
    } catch (err) {
        console.debug(`field: ${fieldName} does not exist in the pdf file`);
    }
    return {field, type};
}

const makePDFReadOnly = (form: PDFForm): PDFForm => {
    const fields = form.getFields() ?? [];
    fields.forEach(field => {
        if (!field.isReadOnly()) {
            field.enableReadOnly();
        }
    });
    return form;
}